//导入vue
import Vue from 'vue'
//导入VueX
import Vuex from 'vuex'

//use一下
Vue.use(Vuex)

//创建仓库
const store=new Vuex.Store({
    //数据
    state:{
        //用户信息
        userInfo:undefined,
        status:false,
    },
    //修改数据的方法
     mutations:{
         CHANGEINFO(state,info){
             //直接保存
             state.userInfo=info;
         }
     }
})
//暴露出去
export default store;